import { z } from 'zod';
import { PutCustomersRequestBody } from '@/src/apis/rest/customers.dtos';

export const DEFAULT_VALUES: PutCustomersRequestBody = {
  nick: '',
  updatedStatus: 'normal',
  updateReason: '',
  name: '',
};

export const formSchema = () => {
  return z.object({
    updateReason: z.string().min(1, '상태 변경 사유를 입력해주세요.'),
  });
};

export const formFields = {
  nick: {
    name: 'nick',
    label: '닉네임',
  },
  administrator: {
    name: 'name',
    label: '담당 관리자',
  },
  updatedStatus: {
    name: 'updatedStatus',
    label: '회원상태',
  },
  updateReason: {
    name: 'updateReason',
    label: '상태 변경 사유',
    placeholder: '회원 상태를 변경하는 사유를 입력해주세요.',
  },
} as const;

export const updatedStatusOptions = [
  { label: '일반 회원', value: 'normal' },
  { label: '정지 회원', value: 'suspended' },
  { label: '탈퇴 회원', value: 'withdrawal' },
];
